<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 48 48">
  <defs>
    <mask id="SVGb9GG3dpr">
      <g fill="none" stroke-linejoin="round" stroke-width="4">
        <rect class="fill-bg-white stroke-bg-white" width="30" height="36" x="9" y="8" rx="2" />
        <path class="stroke-bg-white" stroke-linecap="round" d="M18 4v6m12-6v6" />
        <path class="stroke-black-solid" stroke-linecap="round" d="M16 19h16m-16 8h12m-12 8h8" />
      </g>
    </mask>
  </defs>

  <path fill="currentColor" d="M0 0h48v48H0z" mask="url(#SVGb9GG3dpr)" />
</svg>
